export enum Theme {
  Default = "default-dsfr",
  LightBlue = "light-blue",
  BordeauxMetropole = "bordeaux-metropole",
  Soliguide = "soliguide",
  MesAidesOrg = "mes-aides-org",
  ArcEnCiel = "arc-en-ciel",
}

export enum ThemeLabel {
  Default = "Thème bleu foncé (DSFR)",
  LightBlue = "Thème bleu clair",
  BordeauxMetropole = "Thème Bordeaux Métropole",
  Soliguide = "Thème Soliguide",
  MesAidesOrg = "mes-aides.org",
  ArcEnCiel = "Thème arc enciel",
}
